import React from "react";
import PropTypes from "prop-types";
import joinClassNames from "../helpers/joinClassNames";
import { ReactComponent as logo } from "../assets/logo.svg";
import { ReactComponent as eye } from "../../assets/images/eye.svg";
import { ReactComponent as message } from "../../assets/images/message.svg";
import { ReactComponent as biomarkers } from "../../assets/images/biomarker.svg";
import { ReactComponent as foodIntolerance } from "../../assets/images/bx-food-intolerance.svg";
import { ReactComponent as recommendations } from "../../assets/images/recommendations.svg";
import { ReactComponent as uploadResults } from "../../assets/images/upload.svg";
import { ReactComponent as dashboard } from "../../assets/images/dashboard.svg";
import { ReactComponent as sidebarLogo } from "../../assets/images/sidebar-logo.svg";
import { ReactComponent as logoPicture } from "../../assets/images/logoPicture.svg";
import { ReactComponent as logoPlaceholder } from "../../assets/images/logo-placeholder.svg";
import { ReactComponent as trashIcon } from "../../assets/images/trash.svg";
import { ReactComponent as close } from "../../assets/images/close.svg";
import { ReactComponent as closeFilled } from "../../assets/images/close-white-filled.svg";
import { ReactComponent as moreOrEqual } from "../../assets/images/moreOrEqual.svg";
import { ReactComponent as lessOrEqual } from "../../assets/images/lessOrEqual.svg";
import { ReactComponent as edit } from "../../assets/images/edit.svg";
import { ReactComponent as editPlus } from "../../assets/images/bx-pencil.svg";
import { ReactComponent as arrowDown } from "../../assets/images/arrowDown.svg";
import { ReactComponent as dndIcon } from "../../assets/images/dndIcon.svg";
import { ReactComponent as sortAsc } from "../../assets/images/sortAsc.svg";
import { ReactComponent as sortDesc } from "../../assets/images/sortDesc.svg";
import { ReactComponent as user } from "../../assets/images/user.svg";
import { ReactComponent as datepicker } from "../../assets/images/datepicker.svg";
import { ReactComponent as copy } from "../../assets/images/copy.svg";
import { ReactComponent as archive } from "../../assets/images/bx-archive-in.svg";
import { ReactComponent as unArchive } from "../../assets/images/bx-archive-out.svg";
import { ReactComponent as cartButton } from "../../assets/images/btn.svg";
import { ReactComponent as activate } from "../../assets/images/bx-power-off.svg";
import { ReactComponent as deactivate } from "../../assets/images/bx-check-circle.svg";
import { ReactComponent as circle } from "../../assets/images/ellipse.svg";
import { ReactComponent as customerResults } from "../../assets/images/bx-calendar-check.svg";
import { ReactComponent as threeDots } from "../../assets/images/three-dots.svg";
import { ReactComponent as uploadCloud } from "../../assets/images/bx-cloud-upload.svg";
import { ReactComponent as partnerUpload } from "../../assets/images/partners/upload_icon.svg";
import { ReactComponent as fileIcon } from "../../assets/images/file-icon.svg";
import { ReactComponent as check } from "../../assets/images/bx-check.svg";
import { ReactComponent as foodAndRecipes } from "../../assets/images/food-and-receipts.svg";
import { ReactComponent as program } from "../../assets/images/program.svg";
import { ReactComponent as content } from "../../assets/images/content.svg";
import { ReactComponent as arrowLeft } from "../../assets/images/arrow-left.svg";
import { ReactComponent as merge } from "../../assets/images/merge.svg";

import { ReactComponent as viewHL7 } from "../../assets/images/viewHL7.svg";
import { ReactComponent as markVerified } from "../../assets/images/markVerified.svg";
import { ReactComponent as markCancelled } from "../../assets/images/markCancelled.svg";
import { ReactComponent as reprocessHL7 } from "../../assets/images/reprocessHL7.svg";
import { ReactComponent as download } from "../../assets/images/bx-download.svg";
import { ReactComponent as viewResults } from "../../assets/images/bx-show-alt.svg";
import { ReactComponent as isCriticalResult } from "../../assets/images/isCriticalResult.svg";
import { ReactComponent as infoCircle } from "../../assets/images/bxs-info-circle.svg";
import { ReactComponent as infoCircleOutline } from "../../assets/images/info-circle.svg";
import { ReactComponent as infoCircleWarning } from "../../assets/images/info-warning.svg";
import { ReactComponent as infoCirclePassword } from "../../assets/images/info-circle-password.svg";

import { ReactComponent as notifications } from '../assets/bx-bell.svg';
import { ReactComponent as errorNotification } from '../assets/error-notification.svg';
import { ReactComponent as fileNotification } from '../assets/file-notification.svg';
import { ReactComponent as clocks } from '../assets/bx-time-five.svg';

import { ReactComponent as favourite } from '../../assets/images/bx-heart-filled.svg';
import { ReactComponent as notFavourite } from '../../assets/images/bx-heart.svg';
import { ReactComponent as smallTrash } from '../../assets/images/bx-trash-alt-small.svg';
import { ReactComponent as partnerTrash } from '../../assets/images/partners/trash.svg';

import { ReactComponent as biomarkerGreenStatus } from '../../assets/images/biomarker-green-status.svg';
import { ReactComponent as biomarkerYellowWarning } from '../../assets/images/biomarker-yellow-warning.svg';
import { ReactComponent as biomarkerRedAlert } from '../../assets/images/biomarker-red-alert.svg';
import { ReactComponent as biomarkerGrayUntested } from '../../assets/images/biomarker-gray-untested.svg';
import { ReactComponent as flask } from '../../assets/images/flask.svg';
import { ReactComponent as search } from '../../assets/images/search.svg';

import { ReactComponent as list } from '../../assets/images/bx-list.svg';
import { ReactComponent as userAttributes } from '../../assets/images/bx-user-attributes.svg';

import { ReactComponent as increaseIcon } from "../../assets/images/rule-action-icons/increase.svg";
import { ReactComponent as avoidIcon } from "../../assets/images/rule-action-icons/avoid.svg";
import { ReactComponent as decreaseIcon } from "../../assets/images/rule-action-icons/decrease.svg";
import { ReactComponent as userSegmentsIcon } from "../../assets/images/user-segments-icon.svg";

import { ReactComponent as downloadPDF } from "../../assets/images/br-download.svg";
import { ReactComponent as downloadRoboGP } from "../../assets/images/br-robogp-download.svg";

import { ReactComponent as endsWith } from "../../assets/images/operators/end-with.svg";
import { ReactComponent as startsWith } from "../../assets/images/operators/start-with.svg";
import { ReactComponent as notEqual } from "../../assets/images/operators/not-equal.svg";
import { ReactComponent as greater } from "../../assets/images/operators/greater.svg";
import { ReactComponent as less } from "../../assets/images/operators/less.svg";
import { ReactComponent as contains } from "../../assets/images/operators/contains.svg";
import { ReactComponent as between } from "../../assets/images/operators/between.svg";
import { ReactComponent as equal } from "../../assets/images/operators/equal.svg";
import { ReactComponent as minBetween } from "../../assets/images/operators/min-between.svg";
import { ReactComponent as maxBetween } from "../../assets/images/operators/max-between.svg";
import { ReactComponent as fitness } from "../../assets/images/fitness.svg";
import { ReactComponent as uiCustomisation } from "../../assets/images/ui-customisation.svg";
import { ReactComponent as general } from "../../assets/images/general.svg";
import { ReactComponent as emails } from "../../assets/images/emails.svg";
import { ReactComponent as thirdPartyServices } from "../../assets/images/third-party-services.svg";
import { ReactComponent as healthProgram } from "../../assets/images/health-program.svg";
import { ReactComponent as nutrition } from "../../assets/images/nutrition.svg";
import { ReactComponent as wellness } from "../../assets/images/wellness.svg";
import { ReactComponent as fitnessProgram } from "../../assets/images/fitness-program.svg";
import { ReactComponent as organisation } from "../../assets/images/organisation.svg";
import { ReactComponent as downloadJSON } from "../../assets/images/download-json.svg";
import { ReactComponent as resend } from "../../assets/images/resend.svg";
import { ReactComponent as admin } from "../../assets/images/admin.svg";
import { ReactComponent as partnerDocument } from "../../assets/images/partners/document-text.svg";
import { ReactComponent as envelope } from "../../assets/images/bx-envelope.svg";
import { ReactComponent as lock } from "../../assets/images/lock.svg";
import { ReactComponent as unlock } from "../../assets/images/unlock.svg";
import { ReactComponent as practitioners } from "../../assets/images/bx-attributes.svg";
import { ReactComponent as checkMark } from "../../assets/images/check-new.svg";
import { ReactComponent as partnerUploadAvatar } from "../../assets/images/partners/icon-btn.svg";

import { ReactComponent as plus } from "../../assets/images/plus.svg";


//practitioners
import { ReactComponent as practitionersEye } from "../../assets/images/practitioners/bx-show-alt.svg";
import { ReactComponent as practitionersApprove } from "../../assets/images/practitioners/bx-check-circle.svg";
import { ReactComponent as practitionersWaitlist } from "../../assets/images/practitioners/bx-time.svg";
import { ReactComponent as practitionersReject } from "../../assets/images/practitioners/bx-x-circle.svg";
import { ReactComponent as practitionersDelete } from "../../assets/images/practitioners/bx-trash-alt.svg";
import { ReactComponent as practitionersFile } from "../../assets/images/practitioners/bx-file.svg";
import { ReactComponent as practitionersDownloadFile } from "../../assets/images/practitioners/bx-download.svg";
import { ReactComponent as practitionersEyeFile } from "../../assets/images/practitioners/bx-show-alt-dasboard.svg";

const iconsMap = {
  fitness,
  healthProgram,
  nutrition,
  wellness,
  fitnessProgram,

  endsWith,
  startsWith,
  notEqual,
  greater,
  less,
  contains,
  equal,
  between,
  favourite,
  minBetween,
  maxBetween,

  notFavourite,
  smallTrash,
  partnerTrash,
  logo,
  sortAsc,
  sortDesc,
  eye,
  message,
  biomarkers,
  foodIntolerance,
  recommendations,
  uploadResults,
  dashboard,
  sidebarLogo,
  logoPicture,
  trashIcon,
  close,
  closeFilled,
  moreOrEqual,
  lessOrEqual,
  edit,
  editPlus,
  arrowDown,
  dndIcon,
  user,
  datepicker,
  copy,
  archive,
  unArchive,
  cartButton,
  activate,
  deactivate,
  customerResults,
  threeDots,
  viewHL7,
  markVerified,
  markCancelled,
  reprocessHL7,
  download,
  viewResults,
  isCriticalResult,
  infoCircle,
  infoCirclePassword,
  infoCircleOutline,
  infoCircleWarning,
  notifications,
  errorNotification,
  fileNotification,
  clocks,
  uploadCloud,
  partnerUpload,
  fileIcon,
  check,
  biomarkerGreenStatus,
  biomarkerYellowWarning,
  biomarkerRedAlert,
  biomarkerGrayUntested,
  foodAndRecipes,
  program,
  content,
  flask,
  search,
  list,
  userAttributes,
  arrowLeft,
  avoidIcon,
  increaseIcon,
  decreaseIcon,
  userSegmentsIcon,
  downloadPDF,
  downloadRoboGP,
  uiCustomisation,
  general,
  emails,
  thirdPartyServices,
  organisation,
  logoPlaceholder,
  downloadJSON,
  resend,
  admin,
  partnerDocument,
  envelope,
  lock,
  unlock,
  practitioners,
  practitionersEye,
  practitionersApprove,
  practitionersWaitlist,
  practitionersReject,
  practitionersDelete,
  practitionersFile,
  practitionersDownloadFile,
  practitionersEyeFile,
  checkMark,
  circle,
  partnerUploadAvatar,
  plus,
  merge
};

const Icon = ({ className, icon, onClick, ...props }) => {
  let Svg = iconsMap[icon];
  const classes = joinClassNames("icon", className);

  return <Svg onClick={onClick} className={classes} {...props} />;
};

Icon.defaultProps = {
  className: "",
  icon: logo,
};

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

export default Icon;
